import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DevelopmentsFilterState {
  name: string
  constructionStatus: string
  location: string
  services: string
  type: string
}

const initialState: DevelopmentsFilterState = {
  name: '',
  constructionStatus: '',
  location: '',
  services: '',
  type: '',
}

const developmentsFilterSlice = createSlice({
  name: 'developments',
  initialState,
  reducers: {
    setConstructionStatusFilter: (state, action: PayloadAction<string>) => {
      state.constructionStatus = action.payload
    },

    setLocationFilter: (state, action: PayloadAction<string>) => {
      state.location = action.payload
    },

    setServicesFilter: (state, action: PayloadAction<string>) => {
      state.services = action.payload
    },

    setTypeFilter: (state, action: PayloadAction<string>) => {
      state.type = action.payload
    },

    clearFilters: (state) => {
      state.constructionStatus = ''
      state.location = ''
      state.services = ''
      state.type = ''
    },
  },
})

export const {
  setConstructionStatusFilter,
  setLocationFilter,
  setServicesFilter,
  setTypeFilter,
  clearFilters,
} = developmentsFilterSlice.actions

export default developmentsFilterSlice.reducer
